import { trackSeeDetails } from 'modules/Analytics';
import { gql, useQuery } from 'modules/GraphQL';
import DataResponseContainer from 'modules/common/components/DataResponseContainer';
import EmptyState from 'modules/common/components/EmptyState';
import React from 'react';
import { MdBackspace } from 'react-icons/md';
import AvailableProfileDetails, { AvailableProfileDetailsProps } from '../components/AvailableProfileDetails';

const DETAILS = gql`
  query availableProfile($_id: ID!) {
    availableProfile(_id: $_id) {
      code
      error
      success
      item {
        _id
        name
        bounty
        bountySearcher
        bountyFinder
        bountyDescription
        platformFees
        sector
        sectorIds
        sectors {
          _id
          name
        }
        occupations {
          _id
          name
        }
        occupationIds
        occupation
        client
        location
        experience
        baseSalary {
          min
          max
        }
        description
        context
        createdBy {
          _id
          name
          title
          image
          isTop
        }
        publishedAt
        createdAt
        updatedAt
        countryIds
        areaSearch {
          areas {
            name
            radius
          }
        }
        currency
      }
    }
  }
`;

const AvailableProfile: React.FC<Omit<AvailableProfileDetailsProps, 'availableProfile'> & { _id: string }> = ({ _id, onSubmit, ...props }) => {
  const { loading, data } = useQuery(DETAILS, { variables: { _id } });
  const exists = !loading && data?.searchedProfile?.item !== null;
  const item = { ...data?.availableProfile?.item };

  React.useEffect(() => {
    if (!item?.name) {
      return;
    }
    trackSeeDetails('available_profile', {
      id: item?._id,
      name: item?.name,
      sectorIds: item?.sectorIds,
      sectorNames: item?.sectors?.map(({ name }: any) => name),
      occupationIds: item?.occupationIds,
      occupationNames: item?.occupations?.map(({ name }: any) => name),
      areaSearch: item?.areaSearch,
    });
  }, [item?.name]);
  return (
    <DataResponseContainer data={data} loading={loading}>
      {!exists ? <EmptyState title="Oups, ce candidat a du être supprimé" icon={MdBackspace} /> : null}
      {exists && <AvailableProfileDetails availableProfile={item} {...props} />}
    </DataResponseContainer>
  );
};

export default AvailableProfile;
